import { SxProps, Theme } from '@mui/material';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { forwardRef, useRef } from 'react';

export function useGridRefs() {
  const containerRef = useRef<HTMLDivElement>(null);
  const apiRef = useGridApiRef();

  return {
    containerRef,
    apiRef,
  };
}

export interface MarkbookRef<TData = unknown> {
  updateData: (data: TData) => void;
}

export function useMarkbookRef<TData = unknown>(
  updateFunction: (data: TData) => void,
): MarkbookRef<TData> {
  return {
    updateData: updateFunction,
  };
}

export function createMarkbookComponent<TProps, TData = unknown>(
  component: React.ForwardRefRenderFunction<MarkbookRef<TData>, TProps>,
) {
  return forwardRef<MarkbookRef<TData>, TProps>(component);
}
export interface GridContainerConfig {
  margin?: number;
  marginTop?: number;
  width?: string;
  mobileWidth?: string;
  borderRadius?: number;
  breakpoint?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export const createGridContainerSx = (config: GridContainerConfig = {}): SxProps<Theme> => {
  const {
    margin = 3,
    marginTop = 0,
    width = '95%',
    mobileWidth = '94%',
    borderRadius = 0,
    breakpoint = 'md',
  } = config;

  return (theme: Theme) => ({
    m: margin,
    mt: marginTop,
    width,
    borderRadius,
    [theme.breakpoints.down(breakpoint)]: {
      mr: 0,
      width: mobileWidth,
    },
  });
};

export const useGridContainer = (config?: GridContainerConfig) => {
  const { containerRef, apiRef } = useGridRefs();
  const containerSx = createGridContainerSx(config);

  return {
    containerRef,
    apiRef,
    containerSx,
  };
};
